import React, { ComponentType, useContext, useMemo } from 'react';
import { genericMemo } from '@direct-frontend/stdlib';

import { VStack } from '../../Stack';
import { ListContext, getTextPresetWithSkin } from '../utils';
import { ColorlessIconProps, IconRole } from '../../../icons';
import { useInternalVerticalAlignWithSkin } from '../../../hooks/useVerticalAlign/useVerticalAlignWithSkin';
import { useTheme } from '../../../lib/theme/ThemeProvider';
export interface ListIconRenderProps {
    icon: ComponentType<ColorlessIconProps>;
    isDisabled?: boolean;
    className?: string;
    role?: IconRole;
}

export const ListIconRender = genericMemo(function ListIconRender(props: ListIconRenderProps) {
    const { icon: Icon, isDisabled, className, role } = props;
    const { size } = useContext(ListContext);
    const textPreset = getTextPresetWithSkin();
    const { addonClasses } = useInternalVerticalAlignWithSkin({ textSize: textPreset, addonType: 'icon' });

    const { iconSize } = useTheme().sizeTokens[size];

    const iconRole = useMemo(() => {
        if (isDisabled) {
            return undefined;
        }

        return role ?? 'main';
    }, [isDisabled, role]);

    return (
        <VStack className={addonClasses}>
            <Icon size={iconSize} color="current" role={iconRole} className={className} />
        </VStack>
    );
});
